import { Injectable } from '@angular/core';

/**
 * Whether an upload batch is running in this window. The upload progress service reports it; the auth service reads it
 * to explain, when the session ends, what happens to the run. Kept apart so neither service depends on the other.
 */
@Injectable({ providedIn: 'root' })
export class ActiveRun {
    private source: () => boolean = () => false;

    public track(source: () => boolean): void {
        this.source = source;
    }

    public isRunning(): boolean {
        return this.source();
    }
}
